import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistorySection from 'Components/HistorySection';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { withHistoryContext } from 'Containers/FormContextHandler';
import type { RelevantDocumentType } from '../definitions';
import { TreatmentHistorySection } from './components';
import { DocumentCreationButtonWithContext } from './components/DocumentCreationButtonWithContext';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<RelevantDocumentType>[] = [];
const OxygenTherapy = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
}: IHistoryContext<IDocumentWithTypeV2<RelevantDocumentType>>): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="treatment.oxygenTherapy.title" />}
    newButton={
      <DocumentCreationButtonWithContext name="oxygenTherapy" text="treatment.oxygenTherapy.newOxygenTherapy" />
    }
  >
    {/** The component below takes care of rendering of all the documents */}
    <TreatmentHistorySection documents={documents} startEdit={startEdit} type="oxygenTherapy" view={view} />
  </HistorySection>
);

export default withHistoryContext(OxygenTherapy);
